module.exports = __webpack_public_path__ + "static/Attributes-ec1ba9d4f138b7f99ba3995952e970fd.png";